import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {WebhookTopicHdrContainerModel} from '../../../../../models/aggregates/webhook';


@Injectable({
  providedIn: 'root'
})
export class WebhookTopicService extends BaseApiTemplateService<WebhookTopicHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'webhook-topic';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'webhook-topic';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'webhook-topic';
    this.httpClient = http;
  }
}
